<template>
	<div>
		<input id="img-message" type="file" class="hidden" @change="onFileChange($event)" accept="image/*" />

		<vx-tooltip delay=".1s" :text="$t('Setting.UploadImage')" position="top">
			<feather-icon
				icon="ImageIcon"
				class="ml-4 mb-1 mt-2 cursor-pointer"
				svgClasses="h-6 w-6"
				@click="openInputFile"
			></feather-icon>
		</vx-tooltip>

		<vs-prompt
			:title="$t('Confirm')"
			@cancel="handleCancel"
			@accept="handleAccept"
			@close="handleClose"
			:accept-text="$t('Submit')"
			:cancel-text="$t('Cancel')"
			:active.sync="activeImagePrompt"
			class="custom-prompt"
		>
			<div>
				<img v-show="localFileURL" :src="localFileURL" alt="img" class="img-chat-message" />
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import {uploadFileToFirebase} from "@/helpers/firebaseDB.js";

export default {
	props: {
		chatKey: {
			type: String,
		},
	},
	data() {
		return {
			file: null,
			localFileURL: null,
			activeImagePrompt: false,
		};
	},
	methods: {
		handleAccept() {
			this.uploadImg();
		},
		handleCancel() {
			document.getElementById("img-message").value = "";
			this.file = null;
		},
		handleClose() {
			document.getElementById("img-message").value = "";
			this.file = null;
		},
		openInputFile() {
			document.getElementById("img-message").click();
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.file = files[0];
			this.localFileURL = URL.createObjectURL(files[0]);
			this.activeImagePrompt = true;
		},
		async uploadImg() {
			const fileBytes = this.file.size;
			if (fileBytes / 1048576 > 1) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Setting.ImageNotAllowed"),
					text: this.$t("Setting.AllowedLogo"),
					time: 7000,
				});
				return;
			}
			this.$vs.loading();
			try {
				const res = await uploadFileToFirebase.call(this, this.file, `/chat/${this.chatKey}/`);
				this.$emit("imageUploadedEmit", res.downloadURL);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
				this.handleUploadError(error);
			}
		},
		handleUploadError(error) {
			switch (error.code) {
				case "storage/unauthorized":
					// User doesn't have permission to access the object
					this.errorUploadNotify("User doesn't have permission to access the object");
					break;
				case "storage/canceled":
					// User canceled the upload
					this.errorUploadNotify("User canceled the upload");
					break;
				case "storage/unknown":
					// Unknown error occurred, inspect error.serverResponse
					// "Ocurrió un error inesperado durante la carga del archivo"
					this.errorUploadNotify("Unknown error occurred, inspect error.serverResponse");
					break;
			}
		},
		errorUploadNotify(message) {
			this.$vs.notify({
				color: "danger",
				title: "Upload Error",
				text: message,
			});
		},
	},
};
</script>

<style lang="scss">
.img-chat-message {
	width: 100%;
	height: auto;
	max-height: 500px;
}

.custom-prompt {
	.vs-dialog {
		max-width: 600px !important;
	}
}
</style>
